import React from 'react';
import { useSelector } from 'react-redux';
import TrailDashboard from '../TrailDashboard';
import CampaignDetails from '../CampaignDetails';
import WcaCampaignDetails from '../WCA/WcaCampaignDetails';

const AppCampaignDetails = () => {
  const { userSub, companyConfigData } = useSelector((state) => state.authenticate);
  if (!userSub?.isUserSub) {
    return <TrailDashboard />;
  }

  return companyConfigData?.wabaPartner === 'skalebot' ? (
    <WcaCampaignDetails />
  ) : (
    <CampaignDetails />
  );
};

export default AppCampaignDetails;
